import LoadingDots from 'components/UI/LoadingDots';
import type { CSSProperties } from 'react';
import { capitalizeWord } from 'utils/strings/string.utils';
import styles from './assets/IntegrationStatusBadge.module.css';

const STATUS_LABELS: Record<string, string> = {
  'api error': 'API Error',
};

const formatStatus = (status: string) => {
  const normalizedStatus = String(status || 'Offline').trim();
  const mappedStatus = STATUS_LABELS[normalizedStatus.toLowerCase()];

  return mappedStatus || capitalizeWord(normalizedStatus);
};

export default function IntegrationStatusBadge({ status }: { status: string }) {
  const displayStatus = formatStatus(status);
  const isLoadingStatus = displayStatus === 'Loading';
  const statusLength = displayStatus.length;
  const fontScale = statusLength > 10 ? 0.72 : statusLength > 8 ? 0.8 : statusLength > 6 ? 0.88 : 1;

  return (
    <div className="d-inline-flex w-auto">
      <div
        className={`rounded-3 text-white ${styles.root}`}
        data-status={displayStatus}
        style={{ '--status-font-scale': fontScale } as CSSProperties}
      >
        {isLoadingStatus ? (
          <span className={styles.loadingContent}>
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
            <LoadingDots />
          </span>
        ) : (
          displayStatus
        )}
      </div>
    </div>
  );
}
